// Copyright © 2006-2020 Lexbe Inc. All rights reserved.

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { CaseConfig } from '../models/case-config.model';
import { CaseConfigTypeId } from '../models/case-config-type.enum';

@Injectable({
	providedIn: 'root'
})
export class CaseConfigService {

	constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

	getCaseConfigs(caseId: string): Observable<CaseConfig[]> {
		return this.http.get<CaseConfig[]>(`${this.appConfigService.getConfig().webApi}/api2/CaseConfigs/${caseId}`)
			.pipe(
				catchError(this.errorHandler.handleError<CaseConfig[]>(`getCaseConfig with CaseId=${caseId}`))
			);
	}

	getAccountCaseConfigsByConfigTypeId(accountId: string, caseId: string, configTypeId: CaseConfigTypeId): Observable<CaseConfig[]> {
		return this.http.get<CaseConfig[]>(`${this.appConfigService.getConfig().webApi}/api2/Accounts/${accountId}/Cases/${caseId}/CaseConfigs/${configTypeId}`)
			.pipe(
				catchError(this.errorHandler.handleError<CaseConfig[]>(`getAccountCaseConfigsByConfigTypeId with CaseId=${caseId} and ConfigTypeId=${configTypeId}`))
			);
	}

	updateCaseConfig(config: CaseConfig): Observable<any> {
		const url = `${this.appConfigService.getConfig().webApi}/api2/CaseConfigs/${config.caseId}`;
		return this.http.put(url, config)
			.pipe(
				catchError(this.errorHandler.handleError<CaseConfig>(`[PUT] CaseConfig failed for CaseId=${config.caseId}`))
			);
	}
}
